import { Collapse } from 'antd'
import React, { useEffect, useState } from 'react'
import { DownOutlined} from '@ant-design/icons'

const FareBreakupShip = ({item}) => {
    const [totalOriginValue, setTotalOriginValue] = useState()
    const [totalDestinationValue, setTotalDestinationValue] = useState()
    useEffect(()=>{
        if(item.individualVASRate?.originCharges?.length > 0 ){
            let flag= 0;
            const sum = item.individualVASRate?.originCharges?.reduce((a, obj) => {
                if(Number(obj.originValue)){
                    return a + Number(obj.originValue);
                }else{
                    flag = 1;
                    return a
                }
            }, 0);
            flag === 0 ? setTotalOriginValue(sum.toFixed(2)) : setTotalOriginValue('To be quoted2')
        }
        if(item.individualVASRate?.destinationCharges?.length > 0 ){
            let flag= 0;
            const sum = item.individualVASRate?.destinationCharges?.reduce((a, obj) => {
                if(Number(obj.destinationValue)){
                    return a + Number(obj.destinationValue);
                }else{
                    flag = 1;
                    return a
                }
            }, 0);
            flag === 0 ? setTotalDestinationValue(sum.toFixed(2)) : setTotalDestinationValue('To be quoted1')
        }
    },[item])
    return (
        <Collapse accordion expandIconPosition='end' className='border-none rounded-lg bg-bgbox' expandIcon={({ isActive }) => <DownOutlined rotate={isActive ? 180 : 0} />}>
            <Collapse.Panel className='border-none rounded-none' header={<HeaderTitle item={item}/>} key={1}>
                <div className="flex items-center justify-between px-4 py-2 bg-[#F3F3F3] gap-5">
                    <span className='text-sm'>Total Shipment Rate</span>
                    <p>{ Number(item.USD_totalShipmentRate) ? `$ ${item?.USD_totalShipmentRate} ( ₹ ${item?.totalShipmentRate})` : item?.totalShipmentRate}</p>
                </div>
                <div className="flex items-center justify-between px-4 py-2 bg-[#F3F3F3] gap-5">
                    <span className='text-sm'>Total Origin Charges</span>
                    <span>{ (Number(totalOriginValue) && totalOriginValue !== 0) ? `$ ${totalOriginValue}` : totalOriginValue ? totalOriginValue : 'No Origin Charges'} </span>
                </div>
                <div className="flex items-center justify-between px-4 py-2 bg-[#F3F3F3] gap-5">
                    <span className='text-sm'>Total Destination Charges</span>
                    <span>{ (Number(totalDestinationValue) && totalDestinationValue !== 0) ? `$ ${totalDestinationValue}` : totalDestinationValue ? totalDestinationValue : 'No Destination Charges'} </span>
                </div>
                <div className="flex items-center justify-between px-4 py-2 bg-[#F3F3F3] font-bold">
                    <p>Ship Freight Charges</p>
                    <p>{ Number(item.USD_totalFreightRate) ? `$ ${item?.USD_totalFreightRate} ( ₹ ${item?.totalFreightRate})` : item?.USD_totalFreightRate}</p>
                </div>
                
            </Collapse.Panel>
            <Collapse.Panel className='border-none rounded-none' header="Container Details" key={2}>
                {
                    item?.containerDetails?.length > 0 ?
                        item?.containerDetails?.map((item,i)=>{
                            return (
                                <div className=" px-4 py-2 bg-[#F3F3F3]" key={i}>
                                    <div className="flex items-center justify-between py-2 gap-5">
                                        <p>Container Size</p>
                                        <p>{item?.containerSize === '20' ? '20FT' : item?.containerSize === '40' ? '40FT' : item?.containerSize === '40HC' ? '40FT HC' : item?.containerSize === '45HC' ? '45FT HC' : ''}</p>
                                    </div>
                                    <div className="flex items-center justify-between py-2 gap-5">
                                        <p>Freight Rate</p>
                                        <p>{ Number(item.freight) ? `$` :''} {item.freight}</p>
                                    </div>
                                    <div className="flex items-center justify-between py-2 gap-5">
                                        <p>Total Rate</p>
                                        <p>{ Number(item.totalRate) ? `$` :''} {item.totalRate}</p>
                                    </div>
                                    <div className="flex items-center justify-between py-2 gap-5">
                                        <p>Validity</p>
                                        <p>{item.validity}</p>
                                    </div>
                                    <div className="flex items-center justify-between py-2 gap-5">
                                        <p>Validity Terms</p>
                                        <p>{item.validity_terms}</p>
                                    </div>
                                    <div className="flex items-center justify-between py-2 gap-5">
                                        <p>Remarks</p>
                                        <p>{item.remarks}</p>
                                    </div>
                                    <hr className='border-primary w-full mt-3'/>
                                </div>
                            )
                        })
                    :
                    <div className="flex items-center justify-between px-4 py-2 bg-[#F3F3F3]">
                        <p>No Container Details</p>
                    </div>
                }
            </Collapse.Panel>
        </Collapse>
    )
}
const HeaderTitle = ({item})=>{
    return(
        <div className="flex items-center justify-between font-bold">
            <p>Ship Freight Charges</p>
            <p>{ Number(item.USD_totalFreightRate) ? `$ ${item?.USD_totalFreightRate} ( ₹ ${item?.totalFreightRate})` : item?.USD_totalFreightRate}</p>
        </div>
    )
}
export default React.memo(FareBreakupShip)